import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../Buttons';

const CancelButton = ({ children, intlId, ...rest }) => (
  <Button {...rest}>
    {children || <FormattedMessage id={intlId || 'CancelButton-label-cancel'} defaultMessage="Cancel" />}
  </Button>
);

export default CancelButton;
